import React from 'react';
import HubspotForm from "components/Hubspot";
import { Card, Container } from 'react-bootstrap';

export default function(){
  return (
    <Container>
      <Card.Body className="shadow bg-white rounded text-center mt-2">
        <HubspotForm 
          portalId="4478780"
          formId="54358be2-7085-4d77-901b-c8a8802fab95"
          defaultValues={{
            firstname:"Robson",
            lastname:"França Machado",
            concordo_em_receber_notificacoes_por_whatsapp: true
          }}
        />
      </Card.Body>
    </Container>
  )
}